import { lazy } from "react";

import TryIntent from "@/components/try-intent/src/try-intent";
import {
    defaultFeatureFlags,
    defaultLabels,
    defaultProductData,
    devopsImageUrls,
    firstImpressionsImageUrls,
    getQueryParams,
    useLabelsLocalized
} from "@/templates/try/cloud/signup/signup-page/src/utils";
import { ClientOnly } from "@/utils/client-only";
import { useLocation } from "@/utils/location-provider";

const SignUpLayoutContainer = lazy(
    () =>
        // @ts-ignore
        import(
            "../../../../../../../../components/signup/bxpkit-signup/src/sign-up-layout-container.tsx"
        )
);

export const LoggedOutDefault = () => {
    const location = useLocation();
    const labels = useLabelsLocalized(defaultLabels);
    const { bundle, edition, layout } = getQueryParams(location?.search ?? "");
    return (
        <ClientOnly>
            <TryIntent intentType="form" productKey={bundle} edition={edition}>
                <SignUpLayoutContainer
                    layout={layout}
                    allowSignupWithGoogle={true}
                    allowSignupWithAllSocialOptions={true}
                    bundleOverride={bundle}
                    editionOverride={edition}
                    productData={defaultProductData}
                    enableFreeBreachTest={true}
                    labels={labels}
                    firstImpressionsImageUrls={firstImpressionsImageUrls}
                    devopsImageUrls={devopsImageUrls}
                    featureFlags={defaultFeatureFlags}
                />
            </TryIntent>
        </ClientOnly>
    );
};
